export const ConvertToNumberWithUnit = (numberValue: number | string) => {

    // Nine Zeroes for Billions
    return Math.abs(Number(numberValue)) >= 1.0e+9

        ? (Math.abs(Number(numberValue)) / 1.0e+9).toFixed(2) + "B"
        : Math.abs(Number(numberValue)) >= 1.0e+6
            ? (Math.abs(Number(numberValue)) / 1.0e+6).toFixed(2) + "M"
            : Math.abs(Number(numberValue)) >= 1.0e+3
                ? (Math.abs(Number(numberValue)) / 1.0e+3).toFixed(2) + "K"
                : Math.abs(Number(numberValue));

}